var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-svg-lvl-3":"spread-block-contour","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 514 430"}},[_c('defs'),_c('g',{attrs:{"id":"Контур"}},[_c('polygon',{staticClass:"lc-c-3",attrs:{"points":"66.88 112.84 66.88 352.73 446.61 352.73 446.61 112.46 420.76 86.61 93.1 86.61 66.88 112.84"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }